import { Component, OnInit } from '@angular/core';
import { config } from 'src/config/config';
import { AccountSettingsService } from 'src/app/shared-layout/header/account-settings/account-setting.service';
import { SupportService } from 'src/app/shared/services/support.service';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Component({
  selector: 'app-version-banner',
  templateUrl: './version-banner.component.html',
  styleUrls: ['./version-banner.component.scss'],
})
export class VersionBannerComponent implements OnInit {
  showBanner = false;
  appVersion = config.VERSION_INFO.APP_VERSION;
  isDismissing = false;

  constructor(
    private accountSettingsService: AccountSettingsService,
    private supportService: SupportService,
    private localizationService: LocalizationService
  ) {}

  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.checkBannerVisibility();
  }

  checkBannerVisibility(): void {
    this.accountSettingsService.getDismissedReleaseVersion().subscribe({
      next: (dismissedVersion: string | null) => {
        this.showBanner = dismissedVersion !== this.appVersion;
      },
      error: () => {
        this.showBanner = false;
      },
    });
  }

  openReleaseNotes(): void {
    window.open(
      this.supportService.getReleaseNotesLink(),
      '_blank',
      'noopener,noreferrer'
    );
  }

  dismissBanner(): void {
    if (this.isDismissing) {
      return;
    }
    this.isDismissing = true;
    this.accountSettingsService
      .dismissReleaseVersion(this.appVersion)
      .subscribe({
        next: () => {
          this.showBanner = false;
          this.isDismissing = false;
        },
        error: () => {
          // Still hide locally so the user is not stuck with a broken dismiss control
          this.showBanner = false;
          this.isDismissing = false;
        },
      });
  }
}
